import React from "react";

const HistoryDetails = () => {
  return (
    <div className="rounded-md h-[235px] bg-white shadow-xl py-4 px-8">
      <div className="w-full h-full flex justify-center items-center text-2xl font-medium">
        You Dont Have History Yet !
      </div>
    </div>
  );
};

export default HistoryDetails;
